export function getUrlWithToken(url: string, token: string | null): string {
    if (!token || url.includes('access_token=')) {
        return url;
    }
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}access_token=${token}`;
}
